import { render } from "./ProductCreateComponent.vue?vue&type=template&id=2dcea322"
import script from "./ProductCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProductCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/ProductCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dcea322"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dcea322', __exports__)) {
    api.reload('2dcea322', __exports__)
  }
  
  module.hot.accept("./ProductCreateComponent.vue?vue&type=template&id=2dcea322", () => {
    api.rerender('2dcea322', render)
  })

}


export default __exports__